import { getLocale } from "@/paraglide/runtime.js";

/**
 * A string carried in every supported UI locale. Mirrors the backend
 * `LocalizedString` shape used by the integrations API.
 */
export interface LocalizedString {
	en: string;
	de: string;
}

/**
 * Pick the right variant of a localized string based on the active Paraglide
 * locale. Returns the English text for any locale other than "de" so we
 * never render an empty string when a new locale is added later.
 */
export const localized = (value: LocalizedString): string =>
	getLocale() === "de" ? value.de : value.en;
